import { render } from "./offersDetails.vue?vue&type=template&id=39ba1b57"
import script from "./offersDetails.vue?vue&type=script&lang=js"
export * from "./offersDetails.vue?vue&type=script&lang=js"

import "./offersDetails.vue?vue&type=style&index=0&id=39ba1b57&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__